import {
  Button,
  Divider,
  Flex,
  Modal,
  Space,
  Text,
  Title,
} from "@mantine/core";
import type { FC } from "react";
import { memo } from "react";

import styles from "./ConfirmModal.module.scss";

const ConfirmModal: FC<{
  opened: boolean;
  title: string | React.ReactNode;
  message: string | React.ReactNode;
  confirmTitle?: string | React.ReactNode;
  onConfirm: () => void;
  onClose: () => void;
}> = ({ title, message, confirmTitle, opened, onClose, onConfirm }) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      padding={10}
      radius={12}
    >
      <Title order={3}>{title}</Title>
      <Divider />
      <Space h={40} />
      <Flex>
        <Text>{message}</Text>
      </Flex>
      <Space h={40} />
      <Divider />
      <Space h={10} />
      <Flex align="center" w="100%" gap={8} justify="center">
        <Button className={styles.modalBackButton} onClick={onClose}>
          戻る
        </Button>

        <Button
          type="submit"
          className={styles.modalSubmitButton}
          onClick={onConfirm}
        >
          {confirmTitle || "決定"}
        </Button>
      </Flex>
    </Modal>
  );
};

export const ConfirmModalMemo = memo(ConfirmModal);
